import { Clock3, Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "wouter";
import { SITE_DETAILS } from "@shared/site";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="footer-logo-wrap">
            <img
              src="/manus-storage/core-strategies-logo_ea1e6c9d.webp"
              alt="CORE Strategies Physical Therapy"
              width="290"
              height="110"
            />
          </div>
          <p>
            One-on-one physical therapy and movement guidance for people who want more options for how they live.
          </p>
          <div className="footer-socials" aria-label="CORE Strategies PT social profiles">
            <a href="https://www.facebook.com/coreptkc" target="_blank" rel="noreferrer"><Facebook size={17} aria-hidden="true" /> Facebook</a>
            <a href="https://www.instagram.com/core_strategies_pt/" target="_blank" rel="noreferrer"><Instagram size={17} aria-hidden="true" /> Instagram</a>
            <a href="https://www.linkedin.com/company/core-strategies-physical-therapy-&-movement-centre---coreptkc/about/" target="_blank" rel="noreferrer"><Linkedin size={17} aria-hidden="true" /> LinkedIn</a>
          </div>
        </div>

        <div>
          <p className="footer-heading">Explore</p>
          <nav className="footer-links" aria-label="Footer navigation">
            <Link href="/services">Services</Link>
            <Link href="/vitality-class">Vitality Program</Link>
            <Link href="/our-team">Our Team</Link>
            <Link href="/patient-resources">Patient Resources</Link>
            <Link href="/blog">Blog</Link>
            <Link href="/contact">Contact</Link>
          </nav>
        </div>

        <div>
          <p className="footer-heading">Visit CORE</p>
          <address className="footer-contact">
            <a href={SITE_DETAILS.directionsUrl} target="_blank" rel="noreferrer">
              <MapPin size={18} aria-hidden="true" />
              <span>{SITE_DETAILS.addressLine1}<br />{SITE_DETAILS.addressLocality}</span>
            </a>
            <a href={SITE_DETAILS.phoneHref}><Phone size={18} aria-hidden="true" /> {SITE_DETAILS.phoneDisplay}</a>
            <a href="mailto:michelle@coreptkc.com"><Mail size={18} aria-hidden="true" /> michelle@coreptkc.com</a>
          </address>
          <p className="footer-hours"><Clock3 size={18} aria-hidden="true" /><span>Monday–Friday<br /><strong>7 a.m.–6 p.m.</strong></span></p>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>© {new Date().getFullYear()} {SITE_DETAILS.businessName}</p>
        <div>
          <Link href="/privacy">Privacy</Link>
          <Link href="/terms">Terms</Link>
          <Link href="/disclaimer">Disclaimer</Link>
          <Link href="/accessibility">Accessibility</Link>
        </div>
      </div>
    </footer>
  );
}
